@if(loader){
<app-loader></app-loader>
}

<p-card [header]="isEditMode ? 'Update Vendor' : 'Create Vendor'">
    <form [formGroup]="vendorDetailsForm">
        <div class="field col-12 flex justify-content-between align-items-center">

            <div class="flex">
                <p-button [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-save" size="small"
                    (click)="saveVendor(vendorDetailsForm.value, isEditMode)">
                </p-button>

                <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                    size="small" (click)="cancel()">
                </p-button>
            </div>



            <div style="display: flex; align-items: center; gap: 10px;">
                <label class="block label-required font-bold">Required Field</label>

               <p-button *ngIf="isEditMode" label="More" (click)="menu.toggle($event)" [raised]="true" severity="info"
                    size="small">
                </p-button>

                <p-tieredMenu #menu [model]="items" [popup]="true"></p-tieredMenu>
            </div>

        </div>



        &nbsp;
        <div class="flex align-items-center">
            <div class="flex align-items-center" style="margin: 0px 25px 5px 2px;">
                <p-checkbox label="Inventory Vendor" formControlName="isInventoryVendor" [binary]="true"
                    value="true"></p-checkbox>
            </div>

            <div class="flex align-items-center" style="margin: 0px 25px 5px 2px;">
                <p-checkbox label="Internal Vendor" formControlName="isInternalVendor" [binary]="true"
                    value="true"></p-checkbox>
            </div>
        </div>

        <div class="grid mt-3">
            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">Vendor Code</label>
                    <div style="display: flex; align-items: center;">
                        <input type="text" pInputText placeholder="e.g V89098" (keydown)="onKeydown($event)"
                            (blur)="checkVendorCode()" [readonly]="isEditMode || isManual || vendor.length > 0"
                            class="w-full" formControlName="vendorCode"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.vendorCode.errors }" />
                        @if (!isEditMode) {
                        <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" *ngIf="vendor.length == 0"
                                (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                                value="true"></p-checkbox>
                        </div>
                        }
                    </div>
                    <small
                        *ngIf="vendorDetailsForm.controls.vendorCode.invalid && vendorDetailsForm.controls.vendorCode.dirty && vendorDetailsForm.controls.vendorCode.errors?.['required']"
                        class="error-message" style="color: red;">
                        Vendor Code is required.
                    </small>
                    <small
                        *ngIf="vendorDetailsForm.controls.vendorCode.invalid && vendorDetailsForm.controls.vendorCode.dirty && vendorDetailsForm.controls.vendorCode.errors?.['pattern']"
                        class="error-message" style="color: red;">
                        Only numeric characters are allowed.
                    </small>
                </div>

                <div class="field text-left">
                    <label for="website">Vendor Description</label>
                    <input pInputText class="w-full" (keydown)="onKeydown($event)"
                        formControlName="vendorDescription" />
                </div>


            </div>

            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">Vendor Name</label>
                    <input pInputText placeholder="e.g Tom Hank" (keydown)="onKeydown($event)"
                        class="w-full" formControlName="vendorName"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.vendorName.errors }" />
                    <small *ngIf="submitted && formControls.vendorName.errors" id="vendorName-error"
                        class="text-red-500">Required field.</small>
                </div>

            </div>
            <div class="col">

                <div class="field text-left flex justify-content-center">
                    <input type="file" (change)="onFileSelected($event)" #fileInput style="display: none">

                    @if (previewImage) {
                    <div style="border: 2px solid; border-radius: 10px; position: relative; object-fit: fill;">
                        <p-image [src]="previewImage" alt="Image" width="150px" height="140" [preview]="true"></p-image>
                    </div>
                    } @else {
                    <label for="fileInput" style="cursor: pointer;" (click)="fileInput.click()">
                        <img src="./assets/upload-logo.jpg" width="100px" alt="Image"
                            style="border: 2px solid; border-radius: 10px; position: static;">
                    </label>
                    }
                    @if (previewImage) {
                    <div class="flex justify-content mt-2" style="align-items:center ;">
                        <p-button class="p-button-outlined ml-2 " severity="danger" icon="pi pi-trash" size="small"
                            (click)="deleteImage()"></p-button>
                    </div>
                    }
                    <!-- <div class="field text-left pt34">
                        <label for="website">Manager Code</label>
                        <input pInputText placeholder="e.g 307" class="w-full" />
                    </div> -->
                </div>

            </div>
        </div>



        <p-tabView>

            <p-tabPanel header="General Information">
                <div class="grid ">
                    <div class="col">
                        <div class="field text-left" formGroupName="address">
                            <label for="address" class="label-required display">Address</label>
                            <input pInputText placeholder="Street Address" class="w-full"
                                (keydown)="onKeydown($event)" formControlName="addressLine1"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.addressLine1.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                                id="name-error" class="text-red-500">Required field.</small>
                            <input pInputText placeholder="Street Address 2" class="w-full mt-1"
                                (keydown)="onKeydown($event)" formControlName="addressLine2" />

                            <div class="flex mt-1">
                                <div>
                                    <input pInputText placeholder="City" class="w-full"
                                        (keydown)="onKeydown($event)" formControlName="city"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.city.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                <!--div class=" ml-1">
                                   
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" formControlName="state"
                                        [suggestions]="filterStates" (onSelect)="setState($event)"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"
                                        (keydown.enter)="focusNextInput($event)"></p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div-->


                                <div class=" ml-1">
                                   
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" formControlName="state"
                                        [suggestions]="filterStates" (onSelect)="setState($event)"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"
                                        (keydown.enter)="focusNextInput($event)">
                                        <ng-template let-state pTemplate="item">
                                            {{ state.stateCode  }} - {{ state.stateName }}
                                        </ng-template>
                                    </p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>


                                <div class="ml-1">
                                    <input pInputText placeholder="Zip" class="w-full"
                                        (keydown)="onKeydown($event)" formControlName="zip"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.zip.errors?.['required']"
                                        id="zip-required-error" class="text-red-500">Zip code is required.</small>
                                    <small
                                        *ngIf="formControls.address.controls.zip.value && formControls.address.controls.zip.value.length !== 6"
                                        id="zip-invalid-error" class="text-red-500">Zip code must be exactly 6
                                        digits.</small>
                                </div>

                            </div>
                            <input pInputText placeholder="Country" class="w-full mt-1"
                                formControlName="country" (keydown)="onKeydown($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.country.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left mt-5">
                            <label for="tags">GSTIN</label>
                            <input pInputText placeholder="GSTIN" class="w-full" formControlName="gstin"
                                (keydown)="onKeydown($event)" />

                        </div>

                        <!--<div class="field text-left mt-4">
                          <label for="termsCode">Payment Terms</label>
                          <div class="p-inputgroup p-lookup">
                              <input pInputText class="w-full" formControlName="termsCode"
                                  (keydown.enter)="focusNextInput($event)" />
                                  <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                  (click)="getTermsCode()"></button>
                          </div>
                      </div>-->

                    </div>
                    <div class="col">

                        <div class="field text-left">
                            <label for="mobile">Phone</label>
                            <input pInputText placeholder="Phone" class="w-full" formControlName="phone"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.phone.errors }"
                                (keydown)="onKeydown($event)" />
                        </div>
                        <div class="field text-left">
                            <label for="phone">Mobile</label>
                            <input pInputText placeholder="Mobile" class="w-full"
                                (keydown)="onKeydown($event)" formControlName="mobile"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors}" />
                            <small *ngIf="submitted && formControls.mobile.errors" id="name-error"
                                class="text-red-500">Invalid mobile number.</small>
                        </div>
                        <div class="field text-left">
                            <label for="email">Email</label>
                            <input pInputText placeholder="Email" class="w-full" formControlName="email"
                                (keydown)="onKeydown($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors }" />
                            <small *ngIf="submitted && formControls.email.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left">
                            <label for="website">Website</label>
                            <input pInputText placeholder="Website" class="w-full"
                                formControlName="website"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.website.errors}"
                                (keydown)="onKeydown($event)" />
                        </div>
                        <div class="field text-left">
                            <label for="tags">Tags</label>
                            <input pInputText placeholder="Tags" class="w-full" formControlName="tags"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.tags.errors}"
                                (keydown)="onKeydown($event)" />
                        </div>
                    </div>
                </div>

            </p-tabPanel>

            <!-- created by Prajakta on date 07/06/2024. created for contact Screen display for the salesperson -->
            <p-tabPanel header="Contacts & Addresses" *ngIf="isEditMode">
                <app-contact-list *ngIf="vendorId && vendorId > 0" [vendorId]="vendorId"></app-contact-list>
            </p-tabPanel>

            <!-- created by Nilesh Borase on date 18/03/2025. created for account payable Screen display for the vendor -->
            <p-tabPanel header="Account Payable" *ngIf="isEditMode">
                <div class="grid">
                    <div class="flex gap-4" style="width: 100%; flex-wrap: wrap;">


                        <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                            <div class="field text-left">
                                <label for="termsCode">Payment Terms</label>
                                <div class="p-inputgroup p-lookup">
                                    <input pInputText class="w-full" formControlName="termsCode"
                                        (keydown.enter)="focusNextInput($event)" [readonly]="true" />
                                    <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                        (click)="getTermsCode()"></button>
                                </div>
                            </div>
                        </div>


                        <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                            <div class="field text-left">
                                <label for="glAccountCode">GL Account</label>
                                <div class="p-inputgroup p-lookup">
                                    <input pInputText class="w-full" formControlName="glAccountCode"
                                        (keydown.enter)="focusNextInput($event)" />
                                    <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                        (click)="getGLAccount()"></button>
                                </div>
                            </div>
                        </div>

                        <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                            <div class="field text-left">
                                <label for="outstandingRec">Outstanding Payables (₹)</label>
                                <input pInputText class="w-full" formControlName="outstandingRec"
                                    readonly [value]="formControls.outstandingRec.value | number:'1.2-2':'en-IN'" />
                            </div>
                        </div>

                        <div class="col">
                            <div class="field text-left">
                                <label for="vendorCredit">Vendor Credits (₹)</label>
                                <input pInputText class="w-full" formControlName="vendorCredit" readonly
                                    [value]="formControls.vendorCredit.value | number:'1.2-2':'en-IN'" />
                            </div>
                        </div>


                        <!-- <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                      <div class="field text-left">
                        <label for="creditLimit">Credit Limit</label>
                        <input pInputText class="w-full" formControlName="creditLimit"
                          [readonly]="formControls.noCreditLimit.value"
                          [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.creditLimit.errors}" />
                      </div>
                    </div> -->

                    </div>
                </div>
            </p-tabPanel>


            <p-tabPanel header="Recent Interactions" *ngIf="isEditMode">

                <div class="flex gap-2 align-items-center m-3">
                    <p-dropdown [options]="months" [(ngModel)]="selectedMonth" (onChange)="onMonthChange($event)"
                        placeholder="Select Month" [ngModelOptions]="{ standalone: true }" optionLabel="name"
                        optionValue="value">
                    </p-dropdown>

                    <p-dropdown [options]="years" [(ngModel)]="selectedYear" (onChange)="onYearChange($event)"
                        placeholder="Select Year" [ngModelOptions]="{ standalone: true }" optionLabel="name"
                        optionValue="value">
                    </p-dropdown>

                    <button pButton type="button" label="Filter" icon="pi pi-filter"
                        (click)="filterByMonthYear()"></button>
                    <div class="flex">
                        <div class="flex align-items-center">
                            <p-button icon="pi pi-refresh" size="small" (click)="refresh()" [rounded]="true"
                                severity="info"></p-button>
                        </div>
                    </div>
                </div>

                <p-table #dt1 [value]="RecentInteractionsData" [scrollable]="true" scrollHeight="300px"
                    styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5"
                    styleClass="p-datatable-sm" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
                    [globalFilterFields]="['productCode']"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10,15,20]" [totalRecords]="RecentInteractionsData.length">
                    <ng-template pTemplate="header">
                        <tr>
                            <!-- <th>
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th> -->
                            <th>Date / Time</th>
                            <th>Type</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Subject</th>
                            <th>Description </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-RecentInteractionsData>
                        <tr>
                            <!-- <td>
                            <p-tableCheckbox [value]="RecentInteractionsData"></p-tableCheckbox>
                        </td> -->
                            <td>{{ RecentInteractionsData.sendDate | date: 'MMMM d, y h:mm a' }}</td>
                            <td>{{RecentInteractionsData.type}}</td>
                            <td>{{RecentInteractionsData.from}}</td>
                            <td>{{RecentInteractionsData.to}}</td>
                            <td>{{RecentInteractionsData.subject}}</td>
                            <td>{{RecentInteractionsData.description}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8">No Records found.</td>
                        </tr>
                    </ng-template>

                </p-table>

            </p-tabPanel>

        </p-tabView>

    </form>
</p-card>
<p-toast></p-toast>
